module.exports = __webpack_public_path__ + "img/mobile-app-daily-award.8464099b.png";